import { BACKEND_URL, API } from '@/config/api';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig, isMicrosoftAuthEnabled } from '@/config/msalConfig';

// Initialize MSAL instance
let msalInstance = null;
if (isMicrosoftAuthEnabled()) {
  msalInstance = new PublicClientApplication(msalConfig);
}

export { BACKEND_URL, API, msalInstance, isMicrosoftAuthEnabled };
